export default "__VITE_ASSET__CRlF06UX__"